module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/iDeal-6e1a181734d3656669c8f814ec0b11e5.svg";